// src/services/billingService.js
import { supabase } from '../lib/supabase'
import { PLANS } from '../utils/constants'

/** Get plan config for a given plan id */
export function getPlan(planId) {
  return PLANS[planId] || PLANS.free
}

/** Check if user can add another transaction based on their plan + current count */
export function canAddTransaction(profile, currentTxnCount) {
  const plan = getPlan(profile?.plan || 'free')
  if (plan.txnLimit === Infinity) return { allowed: true }
  if (currentTxnCount < plan.txnLimit) return { allowed: true }
  return {
    allowed: false,
    reason: `You've reached the ${plan.txnLimit}-transaction limit on the ${plan.name} plan.`,
  }
}

/** Check if user has access to full reports (Premium/Enterprise only) */
export function hasFullReports(profile) {
  const plan = getPlan(profile?.plan || 'free')
  return plan.fullReports
}

/** Fetch payment history for current user */
export async function fetchPaymentHistory() {
  const { data, error } = await supabase
    .from('payments')
    .select('*')
    .order('created_at', { ascending: false })
  if (error) return { data: [], error: error.message }
  return { data, error: null }
}

/**
 * mockUpgrade — kept for admin manual upgrades (offline payments, comps etc.)
 * Real web checkout now uses razorpayService.js + Edge Functions.
 */
export async function mockUpgrade(userId, planId) {
  const plan = getPlan(planId)
  const now = new Date()
  const expiresAt = plan.billing === 'per month'
    ? new Date(now.getFullYear(), now.getMonth() + 1, now.getDate())
    : null

  const { data, error } = await supabase
    .from('profiles')
    .update({
      plan: planId,
      plan_started_at: now.toISOString(),
      plan_expires_at: expiresAt ? expiresAt.toISOString() : null,
    })
    .eq('id', userId)
    .select()
    .single()

  if (error) return { data: null, error: error.message }

  if (plan.price) {
    await supabase.from('payments').insert({
      user_id: userId,
      plan: planId,
      amount: plan.price,
      currency: 'INR',
      status: 'success',
      razorpay_order_id: 'manual_' + Date.now(),
      razorpay_payment_id: 'offline_payment',
    })
  }
  return { data, error: null }
}
